const vehicleList = [
    "Abarth",
    "Alfa Romeo",
    "Aston Martin",
    "Audi",
    "BAIC",
    "Bentley",
    "BMW",
    "BYD",
    "Cadillac",
    "Chery",
    "Citroën",
    "Dayun",
    "DFSK",
    "Fiat",
    "Ford",
    "Foton",
    "GWM",
    "Haval",
    "Hino",
    "Honda",
    "Hyundai",
    "Infiniti",
    "Isuzu",
    "JAC",
    "Jaguar",
    "Jeep",
    "Kia",
    "Land Rover",
    "Leapmotor",
    "Lexus",
    "MAN",
    "Mahindra",
    "Mazda",
    "Mercedes-Benz",
    "Mini",
    "Mitsubishi",
    "Nissan",
    "Opel",
    "Peugeot",
    "Porsche",
    "Renault",
    "Scania",
    "Škoda",
    "Subaru",
    "Suzuki",
    "Toyota",
    "UD Trucks",
    "Volkswagen",
    "Volvo",
    "Volvo Trucks"
];

export default vehicleList;